/** Provides functionality to augment new task data with defaults. */
// @ts-check
import { useFilterContext } from '@/features/tasks/hooks/list/use-list-filters';
import { useTasksContext } from '@/features/tasks/context/TasksContext.def';
import { augmentTask } from '@/features/tasks/utils/mutations/newTaskLogicUtils';

const useNewTaskLogic = () => {
  const { hiddenProjects, hiddenContexts } = useFilterContext();
  const { projectDisplayMap, contextDisplayMap } = useTasksContext();

  const augmentNewTaskWithDefaults = (taskPayload, allTasks) => {
    return augmentTask(
      taskPayload,
      allTasks,
      projectDisplayMap,
      hiddenProjects,
      contextDisplayMap,
      hiddenContexts,
    );
  };

  return { augmentNewTaskWithDefaults };
};

export default useNewTaskLogic;
